import React,{ useContext, useEffect, useReducer, useState } from "react";
import { HbrCancel, HbrCloseIcon, HbrEmoticonIcon, HbrKeypadIcon, HbrLikeEmoji,HbrLoveEmoji, HbrPrayEmoji, HbrSendIcon } from "../newComponents/Mycustomsvgicons";
import { actionConsts, reducer } from "../newComponents/StateManager";
import { format } from "date-fns";
import { AuthContext } from "../AuthContext";
import db, { realTimeDB } from "../firebase";
import { get, off, onValue, ref, set } from "firebase/database";
import { EmojisSheetContent } from "../newComponents/CustomEmojisSheet";
import { SendLiveComment, formatNumber } from "../newComponents/GeneralClasses";
import { doc, setDoc } from "firebase/firestore";
import { CustomAlertDialog } from "../newComponents/CustomAlertDialog";
import { useNavigate } from "react-router-dom";



const CommentInput = () => {
   const [showTextarea,setShowTextArea]=useState(false);
   const [emojisArray,setEmojisArray]=useState([]);
   const [likeemojiClked,setLikeClicked]=useState([]);
   const [loveemojiClked,setLoveClicked]=useState([]);
   const [prayemojiClked,setPrayClicked]=useState([]);
   const [state,dispatch]=useReducer(reducer,{message: "",showEmojis: false,progressIndicator: false, loveCount: "", likesCount:"", prayCount: "",alertMessage: "", showAlert: false});
   const docID = format(new Date(),"yyyyMMddHHmmss");
   const date = format(new Date(), "yyyy-MM-dd");
   const alphabets = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"
   const randomUUid = `${Math.floor(Math.random() * 10000)}${alphabets.charAt(Math.floor(Math.random() * alphabets.length))}`
   const timestamp = new Date().getTime();
   const {userName} = useContext(AuthContext);
   const {profile_pic} = useContext(AuthContext);
   const {verifiedUid} = useContext(AuthContext);
   const {bloggerid} = useContext(AuthContext);
   const navigate = useNavigate();


   const handleSendComment=async(e)=>{
      e.preventDefault()
      if(verifiedUid){
         SendLiveComment(docID,userName,bloggerid,state.message,profile_pic,"",timestamp,date)
         .then((res)=>{
            if(res === true){
               dispatch({type: actionConsts.MESSAGE, payload: ""});
            }
         }).catch((err)=>{

         });
      
      }else{
         let tempName = localStorage.getItem("userName");
         if(!tempName){
            localStorage.setItem("userName",`hbrUser${randomUUid}`);
            tempName = localStorage.getItem("userName");

            try {
               await setDoc(doc(db,"reviewComments",docID),{
                   docID,
                   userName: tempName,
                   userID: tempName,
                   message: state.message,
                   userPic: profile_pic,
                   emoji: "",
                   timestamp,
                   date
                });
                dispatch({type: actionConsts.ALERT_MESSAGE,payload: `As a non registered user of the App, your comment will only appear after the host approval. To prevent this behaviour visit the home page to create an account. you can revisit the live section after creating the account.`});
                dispatch({type: actionConsts.SHOWALERT,payload: true});
                dispatch({type: actionConsts.MESSAGE, payload: ""});
           } catch(err){
            console.log(err)
           }
          
         }else{
            try {
               await setDoc(doc(db,"reviewComments",docID),{
                  docID,
                  userName: tempName,
                  userID: tempName,
                  message: state.message,
                  userPic: profile_pic,
                  emoji: "",
                  timestamp,
                  date
                });
                dispatch({type: actionConsts.ALERT_MESSAGE,payload: `As a non registered user of the App, your comment will only appear after the host approval. To prevent this behaviour visit the home page to create an account. you can revisit the live section after creating the account.`});
                dispatch({type: actionConsts.SHOWALERT,payload: true});
                dispatch({type: actionConsts.MESSAGE, payload: ""});
           } catch(err){
            console.log(err)
           }
         }
   
      }
   };


   const handleGetEmojis=async()=>{
      dispatch({type: actionConsts.SHOWEMOJIS, payload: true});
      dispatch({type: actionConsts.PROGRESSINDICATOR, payload: true});
      const emojisSnapshot = await get(ref(realTimeDB,"emojis"));
      if(emojisSnapshot.exists()){
         const allEmojis = emojisSnapshot.val();
         const emojisChildArray = Object.keys(allEmojis).map(key => ({
            id: key,
            ...allEmojis[key]
         }));
         setEmojisArray(emojisChildArray);
         dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
      }else{
         dispatch({type: actionConsts.PROGRESSINDICATOR, payload: false});
      }
   };

   const handleCloseEmojisheet=(res)=>{
         if(res === true){
            dispatch({type: actionConsts.SHOWEMOJIS, payload: false});
         }
   };

   const handleViewClicked=async(actionType)=>{
   
      if(actionType === "LikeEmoji"){

         const likessnapshot = await get(ref(realTimeDB,`live/${date}/likeEmoji`));
         if (likessnapshot.exists()) {
            if (likessnapshot.val() === null || likessnapshot.val() === 0) {
               set(ref(realTimeDB,`live/${date}/likeEmoji`),1);
            }else{
               set(ref(realTimeDB,`live/${date}/likeEmoji`),likessnapshot.val() + 1);
            }
         }else{
            set(ref(realTimeDB,`live/${date}/likeEmoji`),1);
         }
      }
      
      if(actionType === "LoveEmoji"){

         const lovesnapshot = await get(ref(realTimeDB,`live/${date}/heartEmoji`));
         if (lovesnapshot.exists()) {
            if (lovesnapshot.val() === null || lovesnapshot.val() === 0) {
               set(ref(realTimeDB,`live/${date}/heartEmoji`),1);
            }else{
               set(ref(realTimeDB,`live/${date}/heartEmoji`),lovesnapshot.val() + 1);
            }
         }else{
            set(ref(realTimeDB,`live/${date}/heartEmoji`),1);
         }
         
      }
      if(actionType === "prayEmoji"){
         const datasnapshot = await get(ref(realTimeDB,`live/${date}/prayEmoji`));
         if (datasnapshot.exists()) {
            if (datasnapshot.val() === null || datasnapshot.val() === 0) {
               set(ref(realTimeDB,`live/${date}/prayEmoji`),1);
            }else{
               set(ref(realTimeDB,`live/${date}/prayEmoji`),datasnapshot.val() + 1);
            }
         }else{
            set(ref(realTimeDB,`live/${date}/prayEmoji`),1);
         }
      };
   };


   useEffect(()=>{
      const date = format(new Date(), "yyyy-MM-dd");
      const likesRef = ref(realTimeDB,`live/${date}/likeEmoji`);
      const heartRef = ref(realTimeDB,`live/${date}/heartEmoji`);
      const prayRef = ref(realTimeDB,`live/${date}/prayEmoji`);

     const likeListener = onValue(likesRef,(snapshot)=>{
         if (snapshot.exists() && snapshot.val() > 1) {
            dispatch({type: actionConsts.LIKECOUNT, payload: snapshot.val()});
            
         }
      });
     const heartListener = onValue(heartRef,(snapshot)=>{
         if (snapshot.exists() && snapshot.val() > 1) {
            dispatch({type: actionConsts.LOVECOUNT, payload: snapshot.val()});
            
         }
      });
     const prayListener = onValue(prayRef,(snapshot)=>{
         if (snapshot.exists() && snapshot.val() > 1) {
            dispatch({type: actionConsts.PRAYCOUNT, payload: snapshot.val()});
         }
      });

      return()=>{
         off(likesRef,likeListener);
         off(heartRef,heartListener);
         off(prayRef,prayListener);
      }

   },[likeemojiClked]);


   useEffect(()=>{
      setLikeClicked(likeemojiClked => [
         ...likeemojiClked,
         <svg
         viewBox="0 0 512 512"
         fill="white"
         height="1.6em"
         width="1.6em">
         <path d="M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2h144c26.5 0 48 21.5 48 48 0 25.3-19.5 46-44.3 47.9 7.7 8.5 12.3 19.8 12.3 32.1 0 23.4-16.8 42.9-38.9 47.1 4.4 7.2 6.9 15.8 6.9 24.9 0 21.3-13.9 39.4-33.1 45.6.7 3.3 1.1 6.8 1.1 10.4 0 26.5-21.5 48-48 48h-73.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192h64c17.7 0 32 14.3 32 32v224c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z" />
       </svg>
         
      ]);
     
      const timeid = setTimeout(() => {
         setLikeClicked([]);
        
      }, 3000);
      return ()=> clearTimeout(timeid);
   },[state.likesCount]);

   useEffect(()=>{
      setLoveClicked(loveemojiClked => [
         ...loveemojiClked,
         <svg
         viewBox="0 0 1024 1024"
         fill="red"
         height="2em"
         width="2em">
         <path d="M923 283.6a260.04 260.04 0 00-56.9-82.8 264.4 264.4 0 00-84-55.5A265.34 265.34 0 00679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 00-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z" />
      </svg>
         
      ]);
     
      const timeid = setTimeout(() => {
         setLoveClicked([]);
      }, 3000);
      return ()=> clearTimeout(timeid);
   },[state.loveCount]);

   useEffect(()=>{
      setPrayClicked(prayemojiClked => [
         ...prayemojiClked,
         <svg
         viewBox="0 0 24 24"
         fill="#D2691E"
         height="2em"
         width="2em"
       >
         <path d="M11.43 9.67c.04.11.07.21.07.33v5.22c0 .5-.19.98-.53 1.35l-2.79 3.05-3.4-3.4L6 15 8.8 2.86a1.114 1.114 0 012.2.25v4.96a2.08 2.08 0 00-.5-.07c-1.1 0-2 .9-2 2v3c0 .28.22.5.5.5s.5-.22.5-.5v-3c0-.55.45-1 1-1 .19 0 .35.07.5.16.12.07.21.16.3.26.03.04.06.08.08.13.02.04.04.08.05.12M2 19l4 3 1.17-1.27-3.45-3.45L2 19m16-4L15.2 2.86a1.114 1.114 0 00-2.2.25v4.96c.16-.04.33-.07.5-.07 1.1 0 2 .9 2 2v3c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-3c0-.55-.45-1-1-1-.19 0-.35.07-.5.16-.12.07-.21.16-.29.26-.03.04-.07.08-.09.13-.02.04-.04.08-.05.12-.04.11-.07.21-.07.33v5.22c0 .5.19.98.53 1.35l2.79 3.05 3.4-3.4L18 15m2.28 2.28l-3.45 3.45L18 22l4-3-1.72-1.72z" />
       </svg>
         
      ]);
     
      const timeid = setTimeout(() => {
         setPrayClicked([]);
      }, 3000);
      return ()=> clearTimeout(timeid);
   },[state.prayCount]);

   const handleShowWriteComment=async()=>{
      const allowCommentSnapshot = await get(ref(realTimeDB,"Banner/hbrLiveSettings/comment"));
      if (allowCommentSnapshot.val() === "enable") {
         setShowTextArea(true);
      }else{
         setShowTextArea(false);
         dispatch({type: actionConsts.ALERT_MESSAGE,payload: "comment section is disabled by host."});
         dispatch({type: actionConsts.SHOWALERT,payload: true});
      }
   };

 

    return ( 
  
         <div className="comment-input flex-spacebetween">
               {state.showAlert && showTextarea &&
            <CustomAlertDialog 
            alertmessage={state.alertMessage} 
            performAction={true}
            actionName={"Home page"}
            dispatchAction={()=>navigate("/")}
            handleCloseDialog={()=>dispatch({type: actionConsts.SHOWALERT,payload: false})}/>
            }
            {state.showAlert && !showTextarea && 
            <CustomAlertDialog 
            alertmessage={state.alertMessage} 
            handleCloseDialog={()=>dispatch({type: actionConsts.SHOWALERT,payload: false})}/>
            }

            {showTextarea &&
               <div className="flex-row2" style={{width:"100%",height:"100%",backgroundColor:"white",paddingLeft:"10px",paddingRight:"5px"}}>
                  <HbrEmoticonIcon width="1.7em" height="1.7em" fillColour="#000000" handleClick={handleGetEmojis} />
                  <HbrCancel width="1.7em" height="1.7em" fillColour="#000000" handleClick={()=>setShowTextArea(false)}/>
                  <textarea type="text" placeholder="Send Comment" 
                     rows={3} value={state.message} 
                     onChange={e => dispatch({type: actionConsts.MESSAGE, payload: e.target.value})}
                  />

                  <div style={{width:"20%"}}>
                  <HbrSendIcon width="2em" height="2em" fillColour="#000000" handleClick={handleSendComment}/>
                  </div>
                  
            </div>
           
            }
            {!showTextarea && 
                  <div style={{padding:"5px",borderRadius:"50%",backgroundColor:"#101010"}}>
                   
                     <HbrKeypadIcon width="1.7em" height="1.7em" fillColour="#f3f3f3" handleClick={() => handleShowWriteComment()}/>
                  </div>
                 
            }
            {!showTextarea && 
                  <div style={{padding:"5px",borderRadius:"50%",backgroundColor:"#101010"}}>
                   <HbrEmoticonIcon width="1.7em" height="1.7em" fillColour="white" handleClick={handleGetEmojis} />
                  </div>  
            }

           

            {!showTextarea && 
                  
               <div className="floatingemojis flex-row2" style={{gap:"20px",borderRadius:"10px",padding:"5px",marginRight:"1.2em",backgroundColor:"#101010"}}>
                  <div className="flex-column2" style={{padding:"2px",position:"relative",caretColor:"transparent",cursor:"pointer"}}
                        onClick={()=>handleViewClicked("LoveEmoji")}>
                 
                     <div className="floatingloveemoji flex-column2" style={{position:"absolute",width:"100%",top:"0px",zIndex:"1"}}> 
                     {loveemojiClked && loveemojiClked.map((Emoji,index)=>(
                        <div className="emojitofloat" key={index}>
                           <div>{Emoji}</div>
                        </div>
                     ))}
                     </div>  
                 
                     <p id="countreactiontext" style={{fontWeight:"bold",color:"white"}}>{formatNumber(state.loveCount)}</p>
                     <div style={{borderRadius:"50%",backgroundColor:"white"}} >
                     <HbrLoveEmoji width="2em" height="2em" fillColour="red"/>
                     </div>
                  </div>

                  <div className="flex-column2" style={{padding:"2px",position:"relative",caretColor:"transparent"}}
                  onClick={()=>handleViewClicked("LikeEmoji")}>

                     <div className="floatinglikeemoji flex-row2" style={{position:"absolute",width:"100%",top:"0px",zIndex:"2",marginRight:"2em"}}> 
                        {likeemojiClked && likeemojiClked.map((Emoji,index)=>(
                           <div className="emojitofloat" key={index}>
                              <div style={{width:"1.8em",height:"1.8em",borderRadius:"50%",backgroundColor:"green",paddingLeft:"2px"}}>{Emoji}</div>
                           </div>
                        ))}
                     </div>  
                
                     <p id="countreactiontext" style={{color:"white",fontWeight:"bold"}}>{formatNumber(state.likesCount)}</p>
                     <HbrLikeEmoji width="2em" height="2em" fillColour="white"/>
                  </div>

                  <div className="flex-column2" style={{position:"relative",caretColor:"transparent",cursor:"pointer"}}
                  onClick={()=>handleViewClicked("prayEmoji")}>

                     <div className="floatingprayemoji flex-column2" style={{position:"absolute",width:"100%",top:"0px",zIndex:"1",marginRight:"1em"}}> 
                        {prayemojiClked && prayemojiClked.map((Emoji,index)=>(
                           <div className="emojitofloat" key={index}>
                              <div>{Emoji}</div>
                           </div>
                        ))}
                     </div>  
                 
                     <p id="countreactiontext" style={{color:"white",fontWeight:"bold"}}>{formatNumber(state.prayCount)}</p>
                     <HbrPrayEmoji width="2em" height="2em" fillColour="white"/>
                  </div>

               </div>
            }

            {state.showEmojis && 
               <div className="emojissheetlayout flex-column1">
                     <div className="emojissheetlayouttop flex-spacebetween" style={{
                           width:"100%",
                           height:"10%",
                           paddingLeft:"5px",
                           paddingRight:"5px",
                           paddingTop:"5px",
                           paddingBottom:"5px",
                           borderBottom:"5px solid #333333",
                           borderTopLeftRadius:"10%",
                           borderTopRightRadius:"10%",
                           boxShadow:"0px 10px 20px rgba(0, 0, 0, 0.19), 0px 6px 6px rgba(0, 0, 0, 0.23)"
                           }}>
                        <h4 style={{color:"white",fontWeight:"bold"}}>Add Reactions</h4>                       
                         <HbrCloseIcon width="2em" height="2em" fillColour="white" handleClick={()=>dispatch({type: actionConsts.SHOWEMOJIS, payload: false})}/>
                     </div>

                     <div className="emojicontentholder flex-row2" style={{gap:"10px",width:"100%",height:"90%",flexWrap:"wrap",overflow:"auto"}}>
                     {emojisArray && emojisArray.map((data) =>(
                           <EmojisSheetContent 
                           key={data.id}
                           url={data.url}
                           closeEmojiLsheet={handleCloseEmojisheet}
                        />
                     ))}
                     </div>

                     {state.progressIndicator && 
                        <div style={{
                           width: "2em",
                           height: "2em",
                           border: "5px solid dimgrey",
                           borderTop: "5px solid white",
                           borderRadius: "50%",
                           animation: "spin2 2s linear infinite"
                        }}>

                        </div>
                     }
               </div>
            }
         </div> 
   );
}
export default CommentInput;